import type { FaireProductEntity } from "../../entity_types/product";

export const p_duv6mkbqmz: FaireProductEntity = {
  token: "p_duv6mkbqmz",
  type: "product",
  name: "Prayer Works Kids Hoodie",
  brandToken: "b_71tesjzfzj",
  brandName: "Elevated Faith",
  imageUrl:
    "https://cdn.faire.com/fastly/b11e05f47b7fddb86c689fcfd90c1373741999f99e504088c9c237e048d6de33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f946d6b333dbd17fee25790d4c9f098a98a5083f0e51177f3a7b0ba9054160a.jpeg",
    "https://cdn.faire.com/fastly/6ce330fe0d13b421ca2d23dd970945a6e9460bf5a573538a4da1ce97785f58a8.jpeg",
    "https://cdn.faire.com/fastly/3ed8fce5a03c62c94080b96cd9884c82e3a50d6b102c6d5b4cf8563094dca935.jpeg",
    "https://cdn.faire.com/fastly/e2ff06e6ea9b1c1236523192f59eb072552e4120838f028a5d02583998477fc6.jpeg",
  ],
  priceDollars: 18,
  description:
    "\nKeep your little ones snug in our kids' hoodies! Designed with an oversized fit for extra comfort, these hoodies are made from super soft, durable fabric and are perfect for layering on cooler days. Whether heading outdoors or relaxing at home, they offer the perfect blend of warmth and style.\n\n“Ask and it will be given to you; seek and you will find; knock and the door will be opened to you.\" -Matthew 7:7\n\nFit: Oversized Fit\nColor: Eggplant\nComposition: 70% Cotton, 30% Polyester\nFeatures: Super Soft, Pre-Shrunk\n",
  tags: [],
  msrpDollars: 29.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:50.434Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
